import React, { useEffect, useState } from "react";
import "./Loader.css";

function Loader() {

    const [showCards, setShowCards] = useState(false);


    useEffect(() => {

        const interval = setInterval(() => {

            setShowCards(prev => !prev);

        }, 2000); // flip every 2 seconds


        return () => clearInterval(interval);

    }, []);


    return (
        <div className="game-loader">

            <div className="loader-circle">

                <div className="chip"></div>


                <div className={`card card-one ${showCards ? "flip" : ""}`}>
                    <img
                        src={
                            showCards
                                ? "/assets/teen_patti/cards/14H.png"
                                : "/assets/teen_patti/cards/BLANK.png"
                        }
                        alt=""
                    />
                </div>



                <div className={`card card-two ${showCards ? "flip" : ""}`}>
                    <img
                        src={
                            showCards
                                ? "/assets/teen_patti/cards/14S.png"
                                : "/assets/teen_patti/cards/BLANK.png"
                        }
                        alt=""
                    />
                </div>



                <div className={`card card-three ${showCards ? "flip" : ""}`}>
                    <img
                        src={
                            showCards
                                ? "/assets/teen_patti/cards/14C.png"
                                : "/assets/teen_patti/cards/BLANK.png"
                        }
                        alt=""
                    />
                </div>


            </div>


            <h2>Joining Table...</h2>
            <p>Please wait</p>

        </div>
    );
}

export default Loader;